import { getTiposIndicadorByField } from "entity/TipoIndicador/all";
import _ from "lodash";
import Report from "report";
import TableReportHelper from "report/helper";

import { format } from 'date-fns'
import Cliente from "entity/Cliente";
import { getIndicadorByField } from "entity/Indicador/all";
import GraficosExtraRelatorio from "../components/LaudoVisitaConsultaRelatorios/GraficosIndicadores/GraficosExtraRelatorio";
import GraficosRelatorio from "../components/LaudoVisitaConsultaRelatorios/GraficosIndicadores/GraficosRelatorio";

export default class LaudoPerdasPeriodo extends Report {
    constructor(configObj) {
        super();

        this.configObj = configObj;
        this.laudos = configObj.laudos;
        this.cliente = configObj.cliente;
        this.apontamentosPorTipo = configObj.apontamentosPorTipo;
        this.detalhaApontamentos = configObj.detalhaApontamentos === "Sim" ? true : false;
    }
    adapterMeta(meta) {
        meta.textoCabecalho1 = this.cliente.nome
            || (
                this.cliente && this.cliente.length && this.cliente.length > 1
                    ? `${this.cliente[0].nome} e mais ${this.cliente.length - 1} ${this.cliente.length === 2 ? 'cliente' : 'clientes'}`
                    : this.cliente[0].nome
            )
            || ""

        let strData = "De: " + this.configObj.filters.dataInicio.split("-").reverse().join("/") + " até " + this.configObj.filters.dataFim.split("-").reverse().join("/")
        meta.textoCabecalho2 = strData
        return meta
    }

    get title() {
        return "Relatório de Indicadores por Período";
    }

    get fileName() {
        if (this.cliente) {
            return this.title + " - " + (this.cliente.nome || "Múltiplos Clientes") + " - " + this.configObj.filters.dataInicio.split("-").reverse().join("-") + " A " + this.configObj.filters.dataFim.split("-").reverse().join("-");
        } else {
            return this.title;
        }
    }

    async render() {
        this.helper = new TableReportHelper(this.configObj);

        let conteudo = [];


        conteudo = conteudo.concat(this.renderHeader())
        for (const fTipoClass of Object.keys(this.apontamentosPorTipo)) {

            const TipoClass = getTiposIndicadorByField(fTipoClass)

            for (const fIndicadorClass of Object.keys(this.apontamentosPorTipo[fTipoClass])) {
                const IndicadorClass = getIndicadorByField(fIndicadorClass)
                let apontamentosProps = _.get(this.apontamentosPorTipo, `${TipoClass.field}.${IndicadorClass.field}`)

                conteudo = conteudo.concat(await this.renderTipoIndicador(TipoClass, IndicadorClass, this.cliente.length ? this.cliente[0] : this.cliente, apontamentosProps.apontamentos, apontamentosProps.mediaAgrupadorList, conteudo.length === 0))
            }

        }

        return conteudo
    }

    renderHeader() {
        const content = []

        return content;
    }

    async renderTipoIndicador(TipoEntity, IndicadorEntity, cliente, apontamentos, mediaAgrupadorList, primeiro) { // pdf da tela de relatórios
        let paramsCliente = await Cliente.getParamsClienteData(cliente, IndicadorEntity, false, TipoEntity)
        const h = this.helper
        let groupByConfig = this.configObj.agrupador ? this.configObj.agrupador : { nome: "Período" }
        let meta = paramsCliente?.meta
        let titulo = IndicadorEntity.fullName + " - " + TipoEntity.fullName
        let dataInicio = format(new Date(this.configObj.filters.dataInicio), 'dd/MM/yyyy')
        let dataFim = format(new Date(this.configObj.filters.dataFim), 'dd/MM/yyyy')
        let field = IndicadorEntity.field

        // // obtendo sumário (grafico e informações)
        // const content = await IndicadorEntity.getGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        const content = await GraficosRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro, field)

        // // obtendo gráfico secundário
        // await IndicadorEntity.getGraficoExtraRelatorio(content, h, mediaAgrupadorList, meta, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim)
        await GraficosExtraRelatorio(content, h, mediaAgrupadorList, meta, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, field)

        // obtendo tabela detalhe
        content.push(this.detalhaApontamentos ? this.renderApontamentoTipoIndicadorTabela(TipoEntity, IndicadorEntity, apontamentos, paramsCliente) : "")

        return content
    }

    renderApontamentoTipoIndicadorTabela(tipo, indicador, apontamentos, paramsCliente) {
        const h = this.helper;

        const columns = indicador.getTableRelApontamentos(paramsCliente, indicador)
        if (!columns) {
            return [
                h.pageBreak(),
            ]
        }

        const content = [
            h.pageBreak({ pageOrientation: 'landscape' }),
            h.panel(
                [
                    h.row(
                        h.title(
                            "Tabela Detalhe - " + indicador.fullName + " - " + tipo.fullName
                            + (
                                paramsCliente && paramsCliente.meta && !['mudaMecanizada', 'bio', 'cm', 'perf'].includes(indicador.field) // indicadores sem meta
                                    ? " - META: " + paramsCliente.meta
                                    : ''
                            ),
                            { fontSize: 12 }
                        ),
                    ),
                ],
                { widths: ["*"], unbreakable: true }
            ),

            h.tablePanel(columns, apontamentos),

        ];



        return content;
    }
}